export const urlAddProtocol = (url: string) =>
  !/^https?:\/\//i.test(url) ? `https://${url}` : url;
